

angular
.module('inkfinder')
.factory('AppointmentApiFormat', function AppointmentApiFormat(
  Session,
  moment,
  _
) {
  // Public methods
  AppointmentApiFormat.format = format;
  /**
  * @name format
  * @description Function to format the input of a new appointment to the object
  * the endpoint requires.
  * @param {object} input The appointment to be formatted.
  * @param {number} status The status of the new appointment.
  * @return {object} appointment Returns the saveda appointment.
  */
  function format(input, status) {
    let appointment = {};
    if (input.adjusted_appointment_date &&
    input.appointment_start_time) {
      appointment.appointment_datetime = moment(input.adjusted_appointment_date)
      .format('YYYY-MM-DD') + ' ' + moment(input.appointment_start_time)
      .format('HH:mm:ss');
    } else if (input.appointment_date && input.appointment_start_time) {
      appointment.appointment_datetime =
      moment(input.appointment_date).format('YYYY-MM-DD') + ' ' +
      moment(input.appointment_start_time).format('HH:mm:ss');
    } else if (input.appointment_datetime) {
      appointment.appointment_datetime =
      moment(input.appointment_datetime).format('YYYY-MM-DD HH:mm:ss');
    }
    if (input.durationHours || input.durationMinutes) {
      let hours = 0;
      let minutes = 0;
      if (input.durationHours) {
        hours = input.durationHours * 60;
      }
      if (input.durationMinutes) {
        minutes = input.durationMinutes;
      }
      appointment.length = parseInt(hours, 10) + parseInt(minutes, 10);
    }

    if (input.adjustedLength) {
      // Used in Complete Appointment Only
      appointment.length = input.adjustedLength;
    }
    if (input.preferred_start_date) {
      appointment.preferred_start_date = input.preferred_start_date;
    }
    if (input.preferred_end_date) {
      appointment.preferred_end_date = input.preferred_end_date;
    }
    if (input.artist) {
      appointment.artist_id = input.artist.id;
    }
    if (input.previously_paid) {
      appointment.previously_paid = input.previously_paid;
    } else {
      appointment.previously_paid = false;
    }
    if (input.estimate_min || input.estimate_min === 0) {
      appointment.estimate_min = parseInt(input.estimate_min, 10);
    }
    if (input.estimate_max || input.estimate_max === 0) {
      appointment.estimate_max = parseInt(input.estimate_max, 10);
    }
    if (input.price) {
      appointment.price = input.price;
    }
    if (input.deposit_amount) {
      let deposit = parseFloat(input.deposit_amount);
      if (deposit > 0) {
        appointment.deposit_amount = deposit;
      } else if (deposit === 0) {
        appointment.deposit_amount = 0;
      } else if (deposit === null) {
        appointment.deposit_amount = null;
      }
    }
    if (input.deposit_required === false) {
      if (input.deposit_amount !== null &&
      !_.isUndefined(input.deposit_amount)) {
        appointment.deposit_amount = 0;
      }
    }
    if (input.project) {
      appointment.project_id = input.project;
    }
    if (input.project_id) {
      // Create Appointment uses This.
      appointment.project_id = input.project_id;
    }
    if (input.preferred_time) {
      appointment.preferred_time = parseInt(input.preferred_time, 10);
    }
    if (input.preferred_start_date) {
      appointment.preferred_start_date =
      moment(input.preferred_start_date).format('YYYY-MM-DD');
    }
    if (input.preferred_end_date) {
      appointment.preferred_end_date =
      moment(input.preferred_end_date).format('YYYY-MM-DD');
    }
    if (input.managed_by) {
      appointment.managed_by = input.managed_by.id;
    }
    if (status) {
      appointment.status_id = status;
    }
    if (input.id) {
      appointment.id = input.id;
    }
    if (input.agreed_to_cancellation_policy) {
      appointment.agreed_to_cancellation_policy =
      input.agreed_to_cancellation_policy;
    }
    if (!_.isUndefined(Session.activeState.association)) {
      appointment.association_id = Session.activeState.association.id;
    }
    appointment.role = Session.activeState.role;
    return appointment;
  }
  return AppointmentApiFormat;
});



// WEBPACK FOOTER //
// ./components/appointments/util/api-format.service.js